const getNonLoginToggleStatus = async ({ store }) => {
  const toggleKey = 'mitra-chat-non-login';
  await store.dispatch('neo/fetchNeoToggles', [toggleKey]);
  return store.getters['neo/getNeoToggles'][toggleKey];
};

export default async function mitraChatMiddleware({ $axios, env, store, app, route }) {
  if (route.name === 'mitra_chat_index') {
    if (!store.getters['auth/isUserLoggedIn'] && !store.getters['user/getMe'].name) {
      const isToggleOn = await getNonLoginToggleStatus({ $axios, env, store });
      if (isToggleOn) return app.router.replace({ name: 'mitra_chat_new', query: route.query });
      return window.location.replace(`${env.WEB_HOST}/aplikasi-mitra`);
    }
    return;
  }
  if (route.name === 'mitra_chat_new') {
    if (store.getters['auth/isUserLoggedIn']) {
      return app.router.replace({ name: 'mitra_chat_index', query: route.query });
    }
    const isToggleOn = await getNonLoginToggleStatus({ $axios, env, store });
    if (isToggleOn) return;
    return window.location.replace(`${env.WEB_HOST}/aplikasi-mitra`);
  }
}
